import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../services/auth2.service";
import {ApiService} from "../../services/api.service";
import {Router} from "@angular/router";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  standalone: false
})
export class LoggedOutComponent implements OnInit {

  constructor(private auth2Service: Auth2Service, private apiService: ApiService,
              private router: Router, private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Signed Out")
  }
  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }

  login(): void {
    this.router.navigateByUrl('/app/login');
  }
}
